import TourOne from "./TourOne";
import {TourTwo} from "./TourTwo";
import InitialBRBizTourWithScores from "./InitialBRBizTourWithScores";
import BRfBizInitialTourReports from "./BRfBizInitialTourReports";
import BRfBizInitialTourTechnical from "./BRfBizInitialTourTechnical";
import BRBizInitialTourVerification from "./BRBizInitialTourVerification";
import BRBizInitialTourAttestation from "./BRBizInitialTourAttestation";
import {BRBizInitialTourCloudIntegrations} from "./BRBizInitialTourCloudIntegrations";
import {BRBizInitialTourDataSharing} from "./BRBizInitialTourDataSharing";
import {BRBIzInitialTourSocialPremium} from "./BRBIzInitialTourSocial";
import BRBizInitialOwnershipNotVerified from "./BRBizInitialOwnershipNotVerified";
import {BRBizInitialTourReportsOwnershipNotVerified} from "./BRBizInitialTourReportsOwnershipNotVerified";
import {BizIntitialTourFree_Scores} from "./BIzInitialTourFree_Scores";
import {BizIntitialTourFree_Scores_NoOwnership} from "./BizInitialTourFree_scores_noOwnership";
import {BizInitialTourFree_Social} from "./BizInitialTourFree_Social";
import {BizInitialTourFree_Technical} from "./BizInitialTourFree_Technical";
import {BizInitial_Social_ProLite} from "./BizInitial_Social_Pro&Lite";
import {BRfPTourInsightsPro} from "./BRfPTourInsightsPro";
import {BRfPortfolioScores} from "./BRfPortfolioScores";
import {BRfPortfolioTourReports} from "./BRfPortfolioTourReports";
import {BRfPortfolioTourReportsNoAccess} from "./BRfPortfolioTourReportsNoAccess";
import {BRfPortfolioTourManage} from "./BRfPortfolioTourManage";

export const indexOfTours = {
    // TourOne: TourOne,
    // TourTwo: TourTwo,
    InitialBRBizTourWithScores: InitialBRBizTourWithScores,
    InitialBRBizTourwScoresReports: BRfBizInitialTourReports,
    InitialBRBizTourWithScoresTechnical: BRfBizInitialTourTechnical,
    InitialBRBizTourVerification: BRBizInitialTourVerification,
    BRBizInitialTourAttestation: BRBizInitialTourAttestation,
    BRBizInitialTourCloudIntegrations: BRBizInitialTourCloudIntegrations,
    BRBizInitialTourDataSharing: BRBizInitialTourDataSharing,
    BRBIzInitialTourSocialPremium: BRBIzInitialTourSocialPremium,
    BRBizInitialTourOwnershipNotVerified: BRBizInitialOwnershipNotVerified,
    BRBizInitialTourReportsOwnershipNotVerified: BRBizInitialTourReportsOwnershipNotVerified,
    BizIntitialTourFree_Scores: BizIntitialTourFree_Scores,
    BizIntitialTourFree_Scores_NoOwnership: BizIntitialTourFree_Scores_NoOwnership,
    BizInitialTourFree_Social: BizInitialTourFree_Social,
    BizInitialTourFree_Technical: BizInitialTourFree_Technical,
    BizInitial_Social_ProLite: BizInitial_Social_ProLite,
    BRfPTourInsightsPro: BRfPTourInsightsPro,
    BRfPortfolioScores: BRfPortfolioScores,
    BRfPortfolioTourReports: BRfPortfolioTourReports,
    BRfPortfolioTourReportsNoAccess: BRfPortfolioTourReportsNoAccess,
    BRfPortfolioManage: BRfPortfolioTourManage



}

const PagesWithTours = new Set();
Object.values(indexOfTours).forEach((tour)=>PagesWithTours.add(tour.url))

export const indexOfToursMeta = {
    numOfTours: Object.keys(indexOfTours).length,
    tourPagesSet: PagesWithTours,

}